import * as Cookie from 'js-cookie'

export const getExpCookie = () => Cookie.get('exp')



// WEBPACK FOOTER //
// ./src/state/analytics/utils/getExpCookie.ts